import Splide from '@splidejs/splide';
import '@splidejs/splide/css/core';
import './news.scss';

// import NewsSlider from './NewsSlider.svelte'

interface SFNewsItem {
  Id: string
  LastModified: string
  PublicationDate: string
  "Title": string
  "Description": string
  "DateCreated": string
  IncludeInSitemap: boolean
  SystemSourceKey: null|string
  UrlName: string|URL
  ItemDefaultUrl: string|URL
  Order: null|number
  AllowComments: boolean
  Summary: string
  Content: string
  Author: string
  SourceName: string
  SourceSite: string
  Provider: string
};

interface AEMNewsItem {
  Title: string;
  Link: string;
  Description: string;
  PubDate: Date;
  strPubDate: string;
  ID: number;
  Enclosure: string;
  NewsStories: number;
  ToggleImages: boolean;
  ContentTitle: string;
  TxtContent: string;
  IconClass: string;
};

const newsSliderDOM = document.getElementById('com-news-slider');
let newsSlider: Splide|undefined = undefined;
let splideSlideLength: number|undefined = undefined;
let mobile = false;
let newsSlides: NodeList|undefined = undefined;

// the breakpoints at which we will do things. We need these values in our custom slide number adjustments, so I hoisted them up here.
const BP = {
  singleSlide: {
    w: 480,
    maxCount: 4,
  },
  doubleSlide: {
    w: 991,
    maxCount: 12,
  },
};

const splideOptions = {
  type: 'loop',
  autoplay: true,
  gap: '1rem',
  perPage:3,
  perMove:3,
  pagination: true,
  breakpoints: {
    [BP.singleSlide.w]: {
      perPage:1,
      perMove:1,
    },
    [BP.doubleSlide.w]: {
      perPage:2,
      perMove:2,
    },
  },
};

let currentPageDOM;

const playPauseHandler = (e)=> {
  if(window.getComputedStyle(playDOM).display === 'none') {
    isPaused = false;
  } else {
    isPaused = true;
  }
}

/**
 * Runs one time, adds spans to use as timers.
 * @param e Event
 */
const paginationMountedHandler = (e)=> {
  const buttons = e.list.querySelectorAll('button');
  // You can add your class to the UL element
  // data.list.classList.add( 'uc-slider-pages' )

  buttons.forEach((_)=> {
    // _.textContent = String( _.page + 1 ) // aria-label takes care of this
    const span = document.createElement('span');
    span.className = 'progress-indicator';
    _.appendChild(span);
  });
};

const tickHandler = (e)=> {
  if(currentPageDOM) currentPageDOM.style.width = `${(e * 100).toFixed(0) || 0}%`;
};

const paginationUpdateHandler = (e)=> {
  currentPageDOM = e.list.querySelector('.is-active').firstChild;
};

async function enableMocking() {
  if (process.env.NODE_ENV !== 'development') return;

  const { worker } = await import('../../../../local-dev/mocks/msw-browser.js');
 
  // `worker.start()` returns a Promise that resolves
  // once the Service Worker is up and ready to intercept requests.
  return worker.start();
}

function adjustSlideCount() {
  // We'll want to do something like this, but should cache which BP we last operated on
  // if(document.body.offsetWidth !<= BP.doubleSlide.w && mobile) return;


  // if we got here because mobile is true, it means we're on desktop width now, and should reinstate our full offering.
  // if(mobile && newsSlides) {
  //   // reinstate all slides

  //   mobile = false;
  //   return;
  // }
  
  if(document.body.offsetWidth <= BP.singleSlide.w && splideSlideLength) {
    newsSlider?.remove('.rm-for-xsmall');
  } else if(document.body.offsetWidth <= BP.doubleSlide.w && splideSlideLength) {;
    newsSlider?.remove('.rm-for-small');
  }

  // we're on mobile, but we haven't adjusted for it yet. Do so, then set the flag to true.
  mobile = true;
}

/**
 * This is the place to put code that needs the Mock Service Worker to be running when doing local dev. Outside of development environments, this will be a no-op.
 * 
 * MSW is all about intercepting network requests and returning mocked data, so if you're working on a feature that needs to make a network request, you can provide a simulated payload,
 * and not ding the server on every refresh. This is, of course, great for slower endpoints, and to work around CORS security.
 * 
 * To intercept a request, you need to define a route and provide a response handler. This is done in the `local-dev/mocks/msq-handlers.js` file.
 */
enableMocking().then(async () => {
  if(newsSliderDOM) {
    newsSlides = newsSliderDOM.querySelectorAll('li');

    newsSlider = new Splide(newsSliderDOM, splideOptions)
      .on('resize', adjustSlideCount)
      .on('pagination:mounted', paginationMountedHandler)
      .on('pagination:updated', paginationUpdateHandler)
      .on('autoplay:playing', tickHandler)
      .mount();
    
    splideSlideLength = newsSlider.length;

    // we have to call it once on init
    adjustSlideCount();

    // console.log('init', {
    //   newsSlides,
    //   newsSlider,
    //   newsSliderDOM,
    //   splideSlideLength,
    //   state: newsSlider.state,
    // });
  };
});